<div class="lmo-frac-detail-orders">
  <div class="order-status-selection-bar">
    <a [routerLink]="['pending']" routerLinkActive="order-status-type-active" class="order-status-type"
      >Pending (<span saAutomatedSelector="lmo_frac_orders__pending_count">{{ pendingCount$ | async }}</span
      >)</a
    >
    <a [routerLink]="['in-progress']" routerLinkActive="order-status-type-active" class="order-status-type"
      >In Progress (<span saAutomatedSelector="lmo_frac_orders__in_progress_count">{{ inProgressCount$ | async }}</span
      >)</a
    >
    <a [routerLink]="['complete']" routerLinkActive="order-status-type-active" class="order-status-type"
      >Complete (<span saAutomatedSelector="lmo_frac_orders__completed_count"></span>{{ completedCount$ | async
      }}<span saAutomatedSelector="lmo_frac_orders__pending_count"></span>)</a
    >
  </div>
  <div class="main-content">
    <div class="orders-side-bar">
      <router-outlet></router-outlet>
    </div>
    <sa-lmo-map class="map"></sa-lmo-map>
  </div>
</div>
